import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink, RouterOutlet, ActivatedRoute} from '@angular/router';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { NzMenuModule } from 'ng-zorro-antd/menu';
import { transition, trigger } from '@angular/animations';
import up from './shared/animations/up.animation';
import left from './shared/animations/left.animation';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [CommonModule, RouterLink, RouterOutlet, NzIconModule, NzLayoutModule, NzMenuModule],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  animations: [
    trigger('shellRoutes', [transition(':increment', left), transition(':decrement', up())]),
  ],
})
export class AppComponent {
    animationState: number = 0;

    constructor(
    private route: ActivatedRoute,
  ) {

  }

    onActivate() {
    this.animationState = this.route.firstChild?.snapshot.data['routeIdx'];
  }

}


